import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { tokens } from '@equinor/eds-tokens';

var _tokens$colors = tokens.colors,
  background = _tokens$colors.ui.background__default.rgba,
  _tokens$colors$intera = _tokens$colors.interactive,
  activeBackground = _tokens$colors$intera.primary__selected_highlight.rgba,
  activeTextColor = _tokens$colors$intera.primary__resting.rgba,
  focusColor = _tokens$colors$intera.focus.rgba,
  disabledIconColor = _tokens$colors$intera.disabled__fill.rgba,
  disabledTextColor = _tokens$colors$intera.disabled__text.rgba,
  hoverBackground = _tokens$colors$intera.table__header__fill_hover.rgba,
  textColor = _tokens$colors.text.static_icons__default.rgba,
  _tokens$spacings$comf = tokens.spacings.comfortable,
  medium = _tokens$spacings$comf.medium,
  large = _tokens$spacings$comf.large,
  small = _tokens$spacings$comf.small,
  typography = tokens.typography.navigation.menu_title;
var menu = {
  background: background,
  spacings: {
    top: small,
    bottom: small,
    left: '0px',
    right: '0px'
  },
  border: {
    type: 'border',
    radius: '4px'
  },
  typography: _objectSpread(_objectSpread({}, typography), {}, {
    color: textColor
  }),
  entities: {
    icon: {
      states: {
        disabled: {
          typography: {
            color: disabledIconColor
          }
        }
      }
    },
    item: {
      spacings: {
        left: large,
        right: large,
        top: medium,
        bottom: medium
      },
      states: {
        active: {
          typography: _objectSpread(_objectSpread({}, typography), {}, {
            color: activeTextColor
          }),
          background: activeBackground
        },
        focus: {
          outline: {
            color: focusColor,
            style: 'dashed',
            type: 'outline',
            width: '2px',
            offset: '2px'
          }
        },
        hover: {
          background: hoverBackground
        },
        disabled: {
          typography: _objectSpread(_objectSpread({}, typography), {}, {
            color: disabledTextColor
          })
        }
      }
    },
    title: {
      spacings: {
        left: large,
        right: large,
        top: small,
        bottom: small
      }
    }
  },
  modes: {
    compact: {
      entities: {
        item: {
          spacings: {
            left: large,
            right: large,
            top: small,
            bottom: small
          }
        }
      }
    }
  }
};

export { menu };
